module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/bucket_small_flat_256_bake.png";